import CommonStyles from 'shared/style/commonPageStyles'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: CommonStyles.AreaDiv,

	SliderDiv: CommonStyles.SliderDiv,
	ContentImg: CommonStyles.ContentImg,
}

export default Style
